<div class="ops-input-with-list-items-container" [class.disabled]="isDisabled">
  <label *ngIf="label" class="ops-select-label">
    {{ label }}
    <span *ngIf="mandatory">*</span>
    <span
      *ngIf="maxSelect && showLimitNote && !isPreview"
      class="ops-select-note on-top"
    >
      {{ 'OPS_INPUT_WITH_LIST_ITEMS.ADD_UP_TO' | translate }} {{ maxSelect }}
    </span>
  </label>

  <div class="ops-select-input-wrapper" [class.disabled]="isDisabled">
    <div
      class="ops-select-input"
      [class.disabled]="isDisabled"
      [class.preview]="isPreview"
    >
      <div *ngIf="isPreview" class="preview"></div>

      <input
        *ngIf="!isPreview"
        type="text"
        [placeholder]="placeholderText | translate"
        [readonly]="maxApplied"
        [disabled]="isDisabled"
        [value]="selectedValue"
        [(ngModel)]="searchQuery"
        (input)="onSearchChange($event)"
        (keydown.enter)="onEnterPressed($event)"
        [attr.autofocus]="setFocus ? true : null"
      />
    </div>
    <button
      *ngIf="searchQuery && !maxApplied"
      class="button-add"
      tabindex="-1"
      (click)="onEnterPressed($event)"
    >
      <svg
        _ngcontent-ng-c1902739518=""
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g _ngcontent-ng-c1902739518="">
          <path
            _ngcontent-ng-c1902739518=""
            id="Vector"
            d="M12 8V16M16 12H8M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke="#feb62e"
          ></path>
        </g>
      </svg>
    </button>
  </div>

  <div *ngIf="noteText && !isPreview" class="ops-select-note">
    {{ noteText }}
  </div>

  <div *ngIf="showError && errorMessage && !isPreview" class="ops-select-error">
    {{ errorMessage }}
  </div>

  <div
    class="selected-items"
    *ngIf="selectedItems.length"
    [class.disabled]="isDisabled || isPreview"
  >
    <ul tabindex="-1">
      <li *ngFor="let item of selectedItems">
        <span
          class="selected-item"
          [class.disabled]="isDisabled || isPreview"
          (click)="removeSelectedItem(item)"
        >
          <button tabindex="-1">x</button>
          {{ item.value || item }}
        </span>
      </li>
    </ul>
  </div>
</div>
